export default __webpack_public_path__ + "static/FritzphoneC4_08-6e3e42c73ae1b94cdb50a54fcc8969a4.webp";